<template>
    <div class="row">
        <!-- SCREEN 1 -->
        <div v-if="screen == 1" class="col-sm-12 col-md-12">
            <h3 class="mb-0">Create a Quote</h3>
            <p>Add items by SKU or search using product name or feature.</p>
            <div class="row mt-3">
                <div class="col-md-4 pb-2">
                    <!-- <label class="text-muted">Location</label>
                    <input
                        type="text"
                        class="form-control"
import AddNonSkuItemModal from "../modals/AddNonSkuItemModal.vue";
                        v-model="selectedLocation"
                        placeholder="Search Dealer"
                        autocomplete="off"
                        @keyup="searchLocation()"
                        :class="{
                            'is-invalid':
                                submitted && v$.selectedLocationId.$error,
                        }"
                    />
                    <span
                        class="text-danger"
                        v-if="v$.selectedLocationId.$errors"
                    >
                        {{ v$.selectedLocationId.$errors[0]?.$message }}
                    </span>
                    <ul class="search-results" v-if="allLocations.length">
                        <li
                            v-for="item in allLocations"
                            :key="item.id"
                            @click="selectLocation(item)"
                        >
                            <div class="row">
                                <div class="col-md-12">
                                    <span class="sku">{{ item.name }}</span>
                                    <span class="product-name"
                                        >{{ item.address }}, {{ item.city }},
                                        {{ item.state }}, {{ item.zip_code }}</span
                                    >
                                </div>
                            </div>
                        </li>
                    </ul> -->
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="name">
                                    Company Name
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    v-model="location.name"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.location.name.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.location.name.$errors"
                                >
                                    {{ v$.location.name.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="name"
                                    >Contact Name</label
                                >
                                <input
                                    type="text"
                                    name="name"
                                    v-model="location.contact_name"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.location.contact_name.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.location.contact_name.$errors"
                                >
                                    {{ v$.location.contact_name.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="email"
                                    >Email</label
                                >
                                <input
                                    type="text"
                                    name="email"
                                    v-model="location.email"
                                    class="form-control"
                                    autofocus
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="phone"
                                    >Phone</label
                                >
                                <input
                                    type="text"
                                    name="phone"
                                    v-model="location.phone"
                                    v-mask="'000-000-0000'"
                                    class="form-control"
                                    autofocus
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="po_number"
                                    >PO Number</label
                                >
                                <input
                                    type="text"
                                    name="po_number"
                                    v-model="po_number"
                                    class="form-control"
                                    autofocus
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 pb-2">
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label
                                    class="form-control-label text-muted"
                                    for="address"
                                    >Address</label
                                >
                                <input
                                    type="text"
                                    name="address"
                                    v-model="location.address"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.location.address.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.location.address.$errors"
                                >
                                    {{ v$.location.address.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label
                                    class="form-control-label text-muted"
                                    for="address"
                                    >Address 2</label
                                >
                                <input
                                    type="text"
                                    name="address"
                                    v-model="location.address_2"
                                    class="form-control"
                                    required
                                    autofocus
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="city"
                                    >City</label
                                >
                                <input
                                    type="text"
                                    name="city"
                                    v-model="location.city"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.location.city.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.location.city.$errors"
                                >
                                    {{ v$.location.city.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-sm-12 col-md-6">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="state"
                                    >State</label
                                >
                                <select
                                    name="state"
                                    class="form-control"
                                    v-model="location.state"
                                    placeholder="State"
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.location.state.$error,
                                    }"
                                >
                                    <option value=""></option>
                                    <template v-for="(state, idx) in allstates" :key="idx">
                                        <option :value="idx">{{idx}}</option>
                                    </template>
                                    
                                </select>
                                <span
                                    class="text-danger"
                                    v-if="v$.location.state.$errors"
                                >
                                    {{ v$.location.state.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="form-group">
                                <label
                                    class="form-control-label text-muted"
                                    for="zip_code"
                                    >Zip Code</label
                                >
                                <input
                                    type="text"
                                    name="zip_code"
                                    v-model="location.zip_code"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.location.zip_code.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.location.zip_code.$errors"
                                >
                                    {{ v$.location.zip_code.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="requested_delivery_date"
                                    >Requested Delivery Date</label
                                >
                                <datepicker
                                    class="form-control"
                                    v-model="requested_delivery_date"
                                    :lower-limit="lowerLimit"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-4 pb-2">
                    <div class="form-group">
                        <label class="text-muted">SEARCH</label>
                        <div class="input-group search-field">
                            <input
                                type="text"
                                class="form-control"
                                v-model="searchTerm"
                                placeholder="Search the store"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                    <ul
                        class="search-results"
                        v-if="searchPricelistsbyTerm.length"
                    >
                        <li
                            v-for="prod in searchPricelistsbyTerm"
                            :key="prod.id"
                            @click="selectProduct(prod, 'term')"
                        >
                            <div class="row">
                                <div class="col-md-8">
                                    <span class="sku">{{ prod.sku }}</span>
                                    <span class="product-name">{{
                                        prod.product_name
                                    }}</span>
                                </div>
                                <div class="col-md-4 text-right">
                                    <span class="price"
                                        >${{
                                            $filters.moneyFormat(prod.price)
                                        }}</span
                                    >
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-md-4 pb-2">
                    <div class="form-group">
                        <label class="text-muted">&nbsp;</label>
                        <span
                            class="add-button btn btn-action d-block"
                            @click="openModal(null, 'add')"
                        >
                            <i class="fa fa-plus-circle" aria-hidden="true"></i>
                            ADD ITEM WITHOUT SKU
                        </span>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <table class="table table-responsive orders">
                        <thead>
                            <tr>
                                <th style="width: 2em"></th>
                                <th>Product Name</th>
                                <th style="width: 8em">SKU</th>
                                <th style="width: 8em">
                                    MSRP
                                </th>
                                <th style="width: 10em" class="text-center">
                                    Quantity
                                </th>
                                <th style="width: 10em" class="text-center">
                                    Unit Price
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Unit Cost
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Total Revenue
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Pricebook Revenue
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Total Cost
                                </th>
                                <th style="width: 8em" class="text-right">
                                    % OFF MSRP
                                </th>
                                <th style="width: 8em" class="text-right">
                                    GM %
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, idx) in products" :key="item.id" :class="item.class_error ? 'class_error' : ''">
                                <td>
                                    <div
                                        class="cursor-pointer"
                                        @click="removeItem(idx)"
                                    >
                                        <i
                                            class="fa fa-times text-danger"
                                            aria-hidden="true"
                                        ></i>
                                    </div>
                                </td>
                                <td>
                                    <b>{{ item.product_name }}</b>
                                </td>
                                <td>{{ item.sku }}</td>
                                <td>
                                    ${{ $filters.moneyFormat(item.msrp) }}
                                </td>
                                <td class="mobile-text-right">
                                    <div
                                        class="quantity-toggle d-flex align-items-center"
                                    >
                                        <input
                                            type="number"
                                            class="form-control border w-100"
                                            min="0"
                                            @change="calculate(idx)"
                                            @keyup="calculate(idx)"
                                            v-model="item.desired_quantity"
                                        />
                                    </div>
                                </td>
                                <td class="mobile-text-right">
                                    <div
                                        class="quantity-toggle d-flex align-items-center"
                                    >
                                        <input
                                            type="number"
                                            class="form-control border w-100"
                                            min="0"
                                            @change="calculate(idx)"
                                            @keyup="calculate(idx)"
                                            v-model="item.desired_pricing"
                                        />
                                    </div>
                                </td>
                                <td class="text-right">
                                    ${{
                                        $filters.moneyFormat(item.cost)
                                    }}
                                </td>
                                <td class="text-right">
                                    ${{
                                        $filters.moneyFormat(item.total_revenue)
                                    }}
                                </td>
                                <td class="text-right">
                                    ${{
                                        $filters.moneyFormat(item.msrp * item.desired_quantity)
                                    }}
                                </td>
                                <td class="text-right">
                                    ${{ $filters.moneyFormat(item.cost * item.desired_quantity) }}
                                </td>
                                <td class="text-right">
                                    {{
                                        $filters.percentFormat(
                                            item.percent_off_msrp
                                        )
                                    }}%
                                </td>
                                <td class="text-right">
                                    {{ $filters.moneyFormat(item.gm_percent) }}%
                                </td>
                            </tr>
                            <tr v-if="products?.length > 0">
                                <td class="subtotal text-right" colspan="7">
                                    <label>Total Gross Margin on Sale</label>
                                </td>
                                <td class="subtotal text-right">
                                    <span class="h6">
                                        ${{
                                            $filters.moneyFormat(
                                                totalGrossMarginOnSaleRevenue
                                            )
                                        }}
                                    </span>
                                </td>
                                <td class="subtotal text-right"></td>
                                <td class="subtotal text-right">
                                    <span class="h6">
                                        ${{
                                            $filters.moneyFormat(
                                                totalGrossMarginOnSaleCost
                                            )
                                        }}
                                    </span>
                                </td>
                                <td class="subtotal text-right" colspan="2">
                                    <span class="h6">
                                        {{
                                            $filters.percentFormat(
                                                totalGrossMarginOnSaleGMPercent
                                            )
                                        }}%
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12 col-md-4">
                    <label class="text-muted">Internal Notes</label>
                    <textarea
                        class="form-control"
                        rows="5"
                        v-model="internal_notes"
                    ></textarea>
                </div>
                <div class="col-sm-12 col-md-4">
                    <label class="text-muted">Dealer Notes</label>
                    <textarea
                        class="form-control"
                        rows="5"
                        v-model="dealer_notes"
                    ></textarea>
                </div>
                <div class="col-sm-12 col-md-6"></div>
            </div>
            <div class="row mt-5 submit-order-button">
                <div class="col-md-8"></div>
                <div class="col-md-4">
                    <button
                        @click="handleSubmit"
                        type="submit"
                        class="btn btn-outline-danger text-uppercase float-end w-100"
                        :class="reviewQuote()"
                    >
                        Submit Quote
                    </button>
                </div>
            </div>
        </div>

        <!-- Add sub user modal -->
        <b-modal
            v-model="modalShow"
            :title="modalType == 'add' ? 'ADD ITEM' : 'EDIT ITEM'"
            hide-footer
        >
            <AddNonSkuItemModal
                v-if="modalShow"
                :modal-data="modalData"
                :modal-type="modalType"
                @close-modal="closeModal"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    requiredIf,
} from "@vuelidate/validators";

import AddNonSkuItemModal from "../modals/AddNonSkuItemModal.vue";

export default {
    props: [],
    emits: [],
    components: { 
        AddNonSkuItemModal 
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let pricelists = computed(function () {
            return store.state.pricelists;
        });
        let allLocations = computed(function () {
            return store.state.allLocations;
        });
        let allstates = computed(function () {
            return store.state.allstates;
        });

        function getAllPricelists(currentLocation) {
            store.dispatch("getAllPricelists", {
                pricelist_id: -1, //MSRP Pricing
                quotes: true
            });
        }

        function getStates() {
            store.dispatch("getStates");
        }

        onMounted(() => {});

        return {
            store,
            user,
            pricelists,
            allLocations,
            allstates,
            getAllPricelists,
            getStates
        };
    },
    data() {
        return {
            v$: useVuelidate(),
            searchSKU: "",
            searchTerm: "",
            products: JSON.parse(localStorage.getItem("products")),
            screen: 1,
            submitted: false,
            thumbnail: [],
            requestedDeliveryDate: new Date(),
            lowerLimit: new Date(),
            selectedLocation: null,
            selectedLocationId: "",
            internal_notes: "",
            dealer_notes: "",
            po_number: '',
            requested_delivery_date: '',
            location: {
                name: '',
                contact_name: '',
                phone: '',
                email: '',
                address: '',
                address_2: '',
                city: '',
                state: '',
                zip_code: '',
            },
            modalShow: false,
            modalType: null,
            modalData: {},
        };
    },
    validations() {
        return {
            // selectedLocationId: { required },
            location: {
                name: { required },
                contact_name: { required },
                // email: { required },
                // phone: { required },
                address: { required },
                // address_2: { required },
                city: { required },
                state: { required },
                zip_code: { required },
            }
        };
    },
    computed: {
        searchPricelistsbyTerm() {
            if (this.searchTerm === "") {
                return [];
            }

            // let matches = 0;

            return this.pricelists.filter((prod) => {
                if (
                    (prod.product_name
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                        prod.sku
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())) 
                            // && matches < 10
                ) {
                    // matches++;
                    return prod;
                }
            });
        },
        totalGrossMarginOnSaleRevenue() {
            let total = 0;
            this.products.forEach((data, idx) => {
                total += data.desired_quantity * data.desired_pricing;
            });
            return total;
        },
        totalGrossMarginOnSaleCost() {
            let total = 0;
            this.products.forEach((data, idx) => {
                total += data.desired_quantity * data.cost;
            });
            return total;
        },
        totalGrossMarginOnSaleGMPercent() {
            let totalRevenue = 0;
            let totalCost = 0;
            let totalGM = 0;
            this.products.forEach((data, idx) => {
                totalRevenue += data.desired_quantity * data.desired_pricing;
                totalCost += data.desired_quantity * data.cost;
            });
            totalGM = ((totalRevenue - totalCost) / totalRevenue) * 100;
            return totalGM;
        },
    },
    mounted() {
        if (this.user.quote_access || this.user.role.name == 'quote_approver') {
            this.getStates();
            this.getAllPricelists(this.currentLocation);
            // this.store.dispatch("getAllLocations");
            this.store.commit("setAllLocations", []);
            
            localStorage.setItem("products", JSON.stringify([]));
            this.store.commit("setProducts", []);
        } else {
            this.$router.push({ name: "dashboard" });
        }
    },
    methods: {
        handleSubmit(e) {
            this.submitted = true;

            this.v$.$validate();
            if (!this.v$.$error) {
                // if ANY fail validation
                this.submitQuote();
            } else {
                // alert('Form failed validation')
            }
        },
        selectProduct(product, type) {
            console.log('product',product)
            let tempOrder = {
                id: product.id,
                sku: product.sku,
                product_name: product.product_name,
                msrp: product.msrp,
                price: product.price,
                cost: product.cost,
                desired_quantity: 1,
                desired_pricing: this.oemPricing(product.msrp).toFixed(2),
                // desired_pricing: product.cost,
                oem_pricing: this.oemPricing(product.msrp),
                oem_gm_percent: this.oemGMPercent(product.msrp, product.cost),
                total_revenue: 0,
                total_cost: 0,
                percent_off_msrp: 0,
                gm_percent: 0,
            };
            this.products.push(tempOrder);
            type == "sku" ? (this.searchSKU = "") : (this.searchTerm = "");

            localStorage.setItem("products", JSON.stringify(this.products));
            this.store.commit("setProducts", this.products);

            this.calculate();
        },
        calculate(idx) {
            this.products.forEach((data, index) => {
                data.total_revenue = this.totalRevenue(
                    data.desired_quantity,
                    data.desired_pricing
                );
                data.total_cost = this.totCost(
                    data.desired_quantity,
                    data.cost
                );
                data.percent_off_msrp = this.percentOffMsrp(
                    data.msrp,
                    data.desired_pricing
                );
                data.gm_percent = this.gmPercent(
                    data.desired_pricing,
                    data.cost
                );
                data.class_error = data.gm_percent < 40;
            });

            var that = this;
            setTimeout(() => {
                localStorage.setItem("products", JSON.stringify(that.products));
                that.store.commit("setProducts", that.products);
            }, 1000);
        },
        removeItem(idx) {
            this.products.splice(idx, 1);

            localStorage.setItem("products", JSON.stringify(this.products));
            this.store.commit("setProducts", this.products);
        },
        submitQuote() {
            let requestQuote = {
                // location_id: this.selectedLocationId,
                location: this.location,
                products: this.products,
                internal_notes: this.internal_notes,
                dealer_notes: this.dealer_notes,
                total_gross_margin_on_sale_revenue:
                    this.totalGrossMarginOnSaleRevenue,
                total_gross_margin_on_sale_cost:
                    this.totalGrossMarginOnSaleCost,
                total_gross_margin_on_sale_gm_percent:
                    this.totalGrossMarginOnSaleGMPercent,
                po_number: this.po_number,
                requested_delivery_date: new Date(
                    this.requested_delivery_date
                ).toLocaleDateString(),
            };
            // this.submitOrder(requestQuote);

            // SAVE QUOTE
            window.emitter.emit("changeLoaderStatus", true);
            axios.post("/api/submit-quote", requestQuote).then((resp) => {
                let quoteId = resp.data.quote_id;

                // SEND QUOTE EMAIL
                requestQuote.quote_id = quoteId;
                requestQuote.type = 'create';
                axios
                    .post("/api/send-quote-email", requestQuote)
                    .then((response) => {
                        // window.emitter.emit("changeLoaderStatus", false);
                    });

                localStorage.setItem("products", JSON.stringify([]));
                this.store.commit("setProducts", []);
                this.products = [];
                this.selectedLocation = null;
                this.selectedLocationId = "";
                this.internal_notes = "";
                this.dealer_notes = "";

                window.emitter.emit("changeLoaderStatus", false);

                this.$router.push({ name: "quotes" });

                setTimeout(() => {
                    window.emitter.emit("alertSuccess", {
                        message:
                            "Quote was created successfully!",
                    });
                }, 3000)
            });
        },
        backToDashboard() {
            this.$router.push({ name: "dashboard" });
        },
        reviewQuote() {
            if (this.products?.length > 0) {
                let ctr = 0;
                this.products.forEach((data, idx) => {
                    if (
                        data.desired_quantity == 0 ||
                        data.desired_quantity == "" ||
                        data.desired_pricing == 0 ||
                        data.desired_pricing == ""
                    )
                        ctr++;
                });
                if (ctr > 0) {
                    return "disabled";
                } else {
                    return "";
                }
            } else {
                return "disabled";
            }
        },
        searchLocation() {
            if (this.selectedLocation.length >= 3) {
                this.store.dispatch("getLocationByInput", {search: this.selectedLocation})
            } else {
                this.store.commit("setAllLocations", []);
                this.selectedLocationId = "";
            }
        },
        selectLocation(loc) {
            this.selectedLocation = loc.name +
                " - " + 
                loc.address +
                ", " +
                loc.city +
                ", " +
                loc.state +
                ", " +
                loc.zip_code;
            this.selectedLocationId = loc.id;
            this.store.commit("setAllLocations", []);
        },
        oemPricing(msrp) {
            return msrp * (1 - 0.44);
        },
        oemGMPercent(msrp, cost) {
            let oemTier1 = msrp * (1 - 0.44);
            return ((oemTier1 - cost) / oemTier1) * 100;
        },
        totalRevenue(quantity, pricing) {
            let total = 0;
            if (quantity && pricing) total = quantity * pricing;
            return total;
        },
        totCost(quantity, cost) {
            let total = 0;
            if (quantity && cost) total = quantity * cost;
            return total;
        },
        percentOffMsrp(msrp, pricing) {
            let percentOff = 0;
            if (msrp && pricing) percentOff = (1 - pricing / msrp) * 100;
            return percentOff;
        },
        gmPercent(pricing, cost) {
            let gm_percent = 0;
            if (pricing && cost)
                gm_percent = ((pricing - cost) / pricing) * 100;
            return gm_percent;
        },
        openModal(data, val, set) {
            this.modalType = val;
            this.modalSet = set;
            this.modalData = data;
            this.modalShow = !this.modalShow;
        },
        closeModal() {
            this.modalShow = !this.modalShow;
            this.getAllPricelists(this.currentLocation);
        },
    },
};
</script>
